var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestimonialComma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFBE1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2667 31.6C12.9333 30.1334 12.1333 28.5333 12.1333 25.8667C12.1333 21.2 15.4667 17.0667 20.1333 14.9333L21.3333 16.6667C16.9333 19.0667 16 22.1334 15.7333 24.1334C16.4 23.7334 17.3333 23.6 18.2667 23.7334C20.6667 24 22.5333 25.8667 22.5333 28.4C22.5333 29.6 22 30.8 21.2 31.7333C20.2667 32.6667 19.2 33.0667 17.8667 33.0667C16.4 33.0667 15.0667 32.4 14.2667 31.6ZM27.6 31.6C26.2667 30.1334 25.4667 28.5333 25.4667 25.8667C25.4667 21.2 28.8 17.0667 33.4667 14.9333L34.6667 16.6667C30.2667 19.0667 29.3333 22.1334 29.0667 24.1334C29.7333 23.7334 30.6667 23.6 31.6 23.7334C34 24 35.8667 25.8667 35.8667 28.4C35.8667 29.6 35.3333 30.8 34.5333 31.7333C33.7333 32.6667 32.5333 33.0667 31.2 33.0667C29.7333 33.0667 28.4 32.4 27.6 31.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialComma);
export default __webpack_public_path__ + "static/media/testimonial-comma.e706fa3f5dcf512377bef8118ef93c49.svg";
export { ForwardRef as ReactComponent };